<template>
  <ams-table
    :heading="heading"
    :ams_api_path="ams_api_path"
    :ams_type="ams_type"
    :ams_fields="ams_fields"
    :describe_belongs_to="describe_belongs_to"
    :filtering="filtering"
    :refresh="refresh"
    :refreshed="doRefresh"
    :reroute_name="reroute_name"
    :ams_template="ams_template"
  />
</template>

<script>
import AmsTable from './AmsTable.vue'
import {humanize} from '@/utils'

export default {
  components: {
    AmsTable
  },
  props: {
    filtering: {
      Type: Object
    },
    refresh: {
      Type: Boolean
    },
    ams_template: {
      Type: Object
    }
  },
  data() {
    return {
      heading: "StorageSpaces",
      ams_type: 'storage-spaces',
      ams_api_path: 'api/admin/v1',
      reroute_name: 'StorageSpaceCreateScreen',
      ams_fields: [
        {
          key: 'attributes.ancestry',
          label: 'Classification',
          sortable: false,
          filterable: true,
          class: 'text-right',
          sortDirection: 'asc',
          // A column that needs custom formatting,
          formatter: 'storageclassification',
        },
       { 
          key: 'attributes.location',
          label: 'Location',
          sortable: true,
          filterable: true,
          class: 'text-left',
          sortDirection: 'asc' 
        },
        { 
          key: 'attributes.storage-access',
          label: 'Storage Access',
          sortable: false,
          filterable: false,
          class: 'text-left',
          sortDirection: 'asc',
          formatter: value => {
              return humanize(value)
          }
        }
      ],
      describe_belongs_to: [
        {
          prepend: '',
          type: 'collections',
          description_attr: 'name',
          append: ''
        }
      ]
    }
  },
  methods: {
    doRefresh() {
      this.emit('refreshed', true)
    }
  }
}
</script>